import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCreatedAt(createdAt: Date): string {
  const day = String(createdAt.getDate()).padStart(2, "0");
  const month = String(createdAt.getMonth() + 1).padStart(2, "0");
  const year = createdAt.getFullYear();
  const time = createdAt.toLocaleTimeString();
  return `${day}/${month}/${year} ${time}`;
}

export function handleBlock(
  input: string,
  remove: boolean = false,
  startFind: string = "```artifact",
  endFind: string = "```"
) {
  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  let pattern;
  if (endFind) {
    pattern = new RegExp(
      `${escapeRegex(startFind)}([\\s\\S]*?)${escapeRegex(endFind)}`,
      "g"
    );
  } else {
    pattern = new RegExp(`${escapeRegex(startFind)}([\\s\\S]*)`, "g");
  }

  const exists = pattern.test(input);
  if (!remove) {
    return { exists, result: input };
  }

  const result = input.replace(pattern, "").trim();
  return { exists, result };
}
